exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Loading>svg {\n  animation: spin 2s linear infinite;\n  margin: auto;\n  vertical-align: middle;\n}\n\n.Loading {\n  position: relative;\n  text-align: center;\n}\n\n.Loading svg {\n  fill: #bdbdc3;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50% ,-50%);\n  z-index: -1;\n}\n\n@keyframes spin {\n\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n", ""]);

// exports
